
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './VoiceAttributeEditForm.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { VAM2types } from "../_loadingHelpers/VAMv2Types"
import Checkbox from '../../moreCore/UI/CheckBox/CheckBox';
import "../../moreCore/UI/CheckBox/CheckBox";

import "../../moreCore/UI/Edit/Edit";
import Edit from '../../moreCore/UI/Edit/Edit';

import "../../moreCore/UI/NumberInput/NumberInput";
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
class VoiceAttributeEditForm extends compose(_StatefulSection) {
    templateString: any = template;


    voiceAttributesContainer: HTMLDivElement;
    toolbar: HTMLDivElement;

    showIsCastOverride: boolean = true;
    

    private _setShowIsCastOverrideAttr(value: boolean) {
        this.showIsCastOverride = value;
        this.UiModder.domClass.toggle(this.toolbar, "w3-hide", !value);
    }

    private _inputNameTemplates: any = {
        is_oversteered_instrumentation_XY_number: `is_oversteered_instrumentation_group{0}_number`,
        instrumentation_groupXY_number_str: `instrumentation_group{0}_number_str`,
        instrumentation_groupXY_number: `instrumentation_group{0}_number`,
        is_oversteered_instrumentation_groupXY_comment: `is_oversteered_instrumentation_group{0}_comment`,
        instrumentation_groupXY_comment: `instrumentation_group{0}_comment`,
    };

    afterSetData() {
        let data = this.currentData as VAM2types.EvProgram;

        if (!this.showIsCastOverride) {
            this.setAttributeValue("is_overwrite_cast", true);
        }

        for (let i = 1; i <= 18; i++) {
            var numberCheckboxKey = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_XY_number, i);
            var numberInputKey = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_number, i);
            var numberStrInputKey = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_number_str, i);

            if (this.getAttributeValue(numberStrInputKey) === "") {
                this.getRegisteredWidgetsByDataKey(numberInputKey)[0].setValue("");
            }

            var commentCheckboxKey = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_groupXY_comment, i);
            var commentInputKey = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_comment, i);

        }

        this._onChange_CB_oversteer(this.getAttributeValue("is_overwrite_cast"));
    }

    hasData(): boolean {
        let result = false;

        let data = this.getCurrentData();
        
        for (let reg of this.registeredInputs) {
            if (!this.showIsCastOverride && reg.dataKey == "is_overwrite_cast") continue; // auslassen, weil in dem Fall wär das immer true

            let value = this.getAttributeValue(reg.dataKey);
            //let value = reg.input.getValue();

            console.debug(this.id + " " + reg.dataKey, value);

            if (!!value) {
                result = true;
                break;
            }
        }

        return result;
    }


    private _setupInstrumentationRows(): void {

        //  18 Zeilen mit Stimmen-Attributen erzeugen
        //
        for (let i = 1; i <= 18; i++) {
            let row = this.UiModder.domConstruct.create("div", {
                className: "flex_row_center width_100 voice-attribute-row"
            }, this.voiceAttributesContainer);

            let numberContainer = this.UiModder.domConstruct.create("div", {
                className: "flex_row_center voiceAttributesContainer voice-attribute-form-number-container"
            }, row);

            let commentContainer = this.UiModder.domConstruct.create("div", {
                className: "flex_row_center voiceAttributesContainer voice-attribute-form-comment-container"
            }, row);

            let input1 = new Checkbox();
            input1.domNode.dataset["key"] = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_XY_number, i);
            input1.setLabel(this.getTranslation(`VoiceAttributeEditForm__group${i}`));
            this.UiModder.domClass.add(input1.domNode, "voice-attribute-number-checkbox");
            input1.setType("toggle");
            input1.placeAt(numberContainer);

            let input2 = new NumberInput();
            input2.setReadonly(true);
            input2.domNode.dataset["key"] = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_number, i);
            this.UiModder.domClass.add(input2.domNode, "voice-attribute-form-number-input" );
            input2.placeAt(numberContainer);


            let input3 = new Checkbox();
            input3.domNode.dataset["key"] = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_groupXY_comment, i);
            input3.setType("toggle");
            input3.placeAt(commentContainer);

            let input4 = new Edit();
            input4.setReadonly(true);
            input4.setIsMultiline(true, 2);
            input4.domNode.dataset["key"] = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_comment, i);
            this.UiModder.domClass.add(input4.domNode, "voice-attribute-form-comment-input");
            input4.placeAt(commentContainer);


            // verstecktes feld für das Zahlen-String-Attribut. Aus dem Web werden immer nur Zahlen gesetzt. Keine String-Codes wie in evis
            let input5 = this.UiModder.domConstruct.create("input", {
                "type": "hidden"
            }, row);
            input5.dataset["key"] = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_number_str, i);
                
        }        

    }

    _onChange_CB_oversteer(value: boolean): void {

        
        if (value === true) {
            // hier wird übersteuert. keine Daten-änderung
        } else {
            // nicht übersteuert.. es wird alles aus dem ref_opus geholt oder direkt aus den Daten (wenn es sich um einen Opus handelt)
            var instrumentationSource = this.getAttributeValue("ref_opus") ? "ref_opus." : "";
            for (let i = 1; i <= 18; i++) {
                let checkboxKey_OversteeredNumber = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_XY_number, i);
                let checkboxKey_OversteeredComment = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_groupXY_comment, i);
                let editKey_numberInput = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_number, i);
                let editKey_commentInput = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_comment, i);

                this.setAttributeValue(checkboxKey_OversteeredNumber, this.getAttributeValue(`${instrumentationSource}${checkboxKey_OversteeredNumber}`));
                this.setAttributeValue(checkboxKey_OversteeredComment, this.getAttributeValue(`${instrumentationSource}${checkboxKey_OversteeredComment}`));
                this.setAttributeValue(editKey_numberInput, this.getAttributeValue(`${instrumentationSource}${editKey_numberInput}`));
                this.setAttributeValue(editKey_commentInput, this.getAttributeValue(`${instrumentationSource}${editKey_commentInput}`));
            }
        }
        this._handleReadonlyState(!value);
    }

    private _handleReadonlyState(readOnly: boolean): void {
        for (let i = 1; i <= 18; i++) {
            let checkboxKey_OversteeredNumber = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_XY_number, i);
            let checkboxKey_OversteeredComment = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_groupXY_comment, i);
            let editKey_numberInput = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_number, i);
            let editKey_commentInput = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_comment, i);


            this.setWidgetReadonly(checkboxKey_OversteeredNumber, readOnly);
            this.setWidgetReadonly(checkboxKey_OversteeredComment, readOnly);
            this.setWidgetReadonly(editKey_numberInput, readOnly || !this.getAttributeValue(checkboxKey_OversteeredNumber));
            this.setWidgetReadonly(editKey_commentInput, readOnly || !this.getAttributeValue(checkboxKey_OversteeredComment));
        }
    }

    protected _onChanged(attribute: string, newValue: any) {

        // NumberINputs/Edits ein/ausschalten
        debugger;
        for (let i = 1; i <= 18; i++) {
            let checkboxKey_OversteeredNumber = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_XY_number, i);
            let checkboxKey_OversteeredComment = this.stringFormat(this._inputNameTemplates.is_oversteered_instrumentation_groupXY_comment, i);
            let editKey_numberInput = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_number, i);
            let editKey_numberStringInput = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_number_str, i);
            let editKey_commentInput = this.stringFormat(this._inputNameTemplates.instrumentation_groupXY_comment, i);

            // NumberInput
            if (attribute == checkboxKey_OversteeredNumber) {
                this.setWidgetReadonly(editKey_numberInput, !newValue);
                if (!newValue) {
                    var numberInput = this.getRegisteredWidgetsByDataKey(editKey_numberInput)[0];
                    this.setAttributeValue(editKey_numberInput, "");
                    numberInput.setValue("");
                }
            }

            // Comment Edit
            if (attribute == checkboxKey_OversteeredComment) {
                this.setWidgetReadonly(editKey_commentInput, !newValue);
                if (!newValue) {
                    var commentInput = this.getRegisteredWidgetsByDataKey(editKey_commentInput)[0];
                    this.setAttributeValue(editKey_commentInput, "");
                    commentInput.setValue("");
                }
            }


            // Number-String-Input (es wird einfach der Zahlen-Wert als String gespeichert damit evis einen Wert bekommt.
            // der Zahlen-String wird im Web nie bearbeitet. nur mitgeschliffen. Deshalb das hidden-input in der Row...
            if (attribute == editKey_numberInput) {
                this.setAttributeValue(editKey_numberStringInput, newValue ? newValue.toString() : "");
            }
        }
        this.emit("change");
    }



    postCreate(): void {
        this.RequestManager.handleAs = "jsonWithDate";

        // Controls zeichnen bevor die StatefulSection losstartet
        this._setupInstrumentationRows();
        super.postCreate.apply(this, arguments as any);

        // -----> ab hier sind die sections und data-keys registriert

        // initial readOnly
        this._handleReadonlyState(false) // wird aber vom initialen setAttribute auf die toggle-checkbox überschrieben
        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(VoiceAttributeEditForm);